import React from "react";
import { Phone, MessageCircle } from "lucide-react";
import { telLink, waLink } from "../lib/data";

export const FloatingActions = () => {
  return (
    <div className="fixed bottom-5 right-4 z-50 flex flex-col gap-3" data-testid="floating-actions">
      <a
        href={waLink()}
        target="_blank"
        rel="noreferrer nofollow"
        data-testid="floating-whatsapp-btn"
        className="group w-14 h-14 rounded-full bg-approval flex items-center justify-center shadow-lg emerald-glow hover:scale-110 transition-transform animate-floaty"
        aria-label="Chat on WhatsApp"
      >
        <MessageCircle className="w-7 h-7 text-white" fill="white" />
      </a>
      <a
        href={telLink}
        data-testid="floating-call-btn"
        className="w-14 h-14 rounded-full gold-gradient flex items-center justify-center shadow-lg animate-pulse-gold hover:scale-110 transition-transform"
        aria-label="Call now"
      >
        <Phone className="w-6 h-6 text-obsidian-900" />
      </a>
    </div>
  );
};
